module.exports = __webpack_public_path__ + "img/player_joined.3e5fe49.gif";